import { render, staticRenderFns } from "./AuditTable.vue?vue&type=template&id=1051f04c&scoped=true"
import script from "./AuditTable.vue?vue&type=script&lang=js"
export * from "./AuditTable.vue?vue&type=script&lang=js"
import style0 from "./AuditTable.vue?vue&type=style&index=0&id=1051f04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051f04c",
  null
  
)

export default component.exports